import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Table from "./table.react";

export default class FormSubmissions extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      notificationSystem,
      formSubmissions: {
        formSubmissions: {
          meta: formSubmissionsMeta,
          sort: formSubmissionsSort
        }
      }
    } = this.props;
    actions.getFormSubmissions(formSubmissionsMeta, formSubmissionsSort).then((
      { error, payload }
    ) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  render() {
    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszystkie zamówienia</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/formSubmissions/formSubmissions.react.js